import { render, staticRenderFns } from "./DestinationsInfo.vue?vue&type=template&id=699b0048&scoped=true&"
import script from "./DestinationsInfo.vue?vue&type=script&lang=js&"
export * from "./DestinationsInfo.vue?vue&type=script&lang=js&"
import style0 from "./DestinationsInfo.vue?vue&type=style&index=0&id=699b0048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699b0048",
  null
  
)

export default component.exports